import { APPLICATION_KEY } from './../../../../../../shared/enums/admin-enum';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { APPLICATION } from 'src/app/shared/enums/admin-enum';
import { PATH_ROUTING } from 'src/app/shared/enums/routing-enums';
import { ApplicationAccessStatusService } from 'src/app/shared/service/application-access-status.service';
import { Spinner } from '../../../../../../core/services/spinner.service';
import { Paging, RequestOption } from '../../../../../../shared/model/common.model';

export const APPS = [
  {
    value: APPLICATION_KEY.CLEAR_ORBIT,
    name: APPLICATION.CLEAR_ORBIT,
    id: 6
  },
  {
    value: APPLICATION_KEY.OTM,
    name: APPLICATION.OTM,
    id: 9
  },
  {
    value: APPLICATION_KEY.QUALITY_SUITES,
    name: APPLICATION.QUALITY_SUITES,
    id: 4
  },
  {
    value: APPLICATION_KEY.RACES_ISUPPLIER,
    name: APPLICATION.RACES_ISUPPLIER,
    id: 2
  },
  {
    value: APPLICATION_KEY.REN_TM,
    name: APPLICATION.REN_TM,
    id: 7
  },
  {
    value: APPLICATION_KEY.REN_TT,
    name: APPLICATION.REN_TT,
    id: 8
  },
  {
    value: APPLICATION_KEY.SDX,
    name: APPLICATION.SDX,
    id: 5
  },
  {
    value: APPLICATION_KEY.SPT,
    name: APPLICATION.SPT,
    id: 3
  },
  {
    value: APPLICATION_KEY.INTELEX_SUPPLIER_AUDIT,
    name: APPLICATION.INTELEX_SUPPLIER_AUDIT,
    id: 1
  },
  {
    value: APPLICATION_KEY.SRM,
    name: APPLICATION.SRM,
    id: 15
  },
  {
    value: APPLICATION_KEY.SUPPLIER_CONNECT,
    name: APPLICATION.SUPPLIER_CONNECT,
    id: 14
  },
];


@Component({
  selector: 'app-application-access-status',
  templateUrl: './application-access-status.component.html',
  styleUrls: ['./application-access-status.component.scss']
})
export class ApplicationAccessStatusComponent implements OnInit {

  apps: any[] = [];
  selectedApps: any[] = [];
  sso = '';
  supplierName = '';
  gsl = '';
  dataSource: MatTableDataSource<any[]> = new MatTableDataSource<any[]>();
  displayedColumns = ['application', 'sso', 'full_Name', 'gsl', 'supplier_Name', 'last_upload', 'action'];
  requestOption = new RequestOption();
  sortTimeoutInstance: any;
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private spinner: Spinner,
    private applicationAccessService: ApplicationAccessStatusService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.getApplications();
  }

  filterData(name, value) {
    const data = value.slice();
    if (data[0] === 'All') {
      data.shift();
    }
    this.selectedApps = data.map(item => item.value);
  }

  getDataTable() {
    this.spinner.show();
    this.applicationAccessService.getData(this.requestOption, this.sso, this.supplierName, this.gsl, this.selectedApps)
    .subscribe((res: any) => {
      this.spinner.hide();
      this.dataSource.data = res.data.content.map(item => {
        item.fullName = item.firstName + ' ' + item.lastName;
        item.application = APPLICATION[item.application];
        item.lastUpload = new Date(item.updatedDate).toLocaleString();
        return item;
      });
      const rq: RequestOption = { ...this.requestOption };
      rq.pagingOptions.totalPages = res.data.totalPages;
      rq.pagingOptions.numberOfElements = res.data.numberOfElements;
      rq.pagingOptions.totalElements = res.data.totalElements;
      this.requestOption = rq;
    });
  }

  onChangeRequestOption(event) {
    this.requestOption = event;
    this.getDataTable();
  }

  revoke(id?) {
    if (id) {
      this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, 'revoke-access', id]);
    } else {
      this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, 'revoke-access']);
    }
  }

  public loadDataTable(gotoFirstPage?: boolean) {
    if (gotoFirstPage) {
      this.requestOption.pagingOptions = new Paging(this.requestOption.pagingOptions.size);
      this.initRequestOption();
    }
    this.getDataTable();
  }

  public initRequestOption() {
    this.requestOption.pagingOptions.totalPages = 0;
    this.requestOption.pagingOptions.numberOfElements = 0;
  }

  search() {
    this.requestOption.pagingOptions.number = 0;
    this.getDataTable();
  }

  public sortData(sort: Sort) {
    if (this.sortTimeoutInstance) {
      clearTimeout(this.sortTimeoutInstance);
    }
    this.sortTimeoutInstance = setTimeout(() => {
      this.requestOption.pagingOptions.sort.sortBy = sort.active;
      this.requestOption.pagingOptions.sort.sortOrder = sort.direction;
      this.getDataTable();
    }, 500);
  }

  getApplications() {
    this.spinner.show();
    this.applicationAccessService.getApplications().subscribe(res => {
      this.spinner.hide();
      if (res.data) {
        const listApp = [];
        // tslint:disable-next-line: forin
        for (const item of res.data) {
          listApp.push({
            value: APPS.filter(el => el.value === item)[0].id,
            name: APPLICATION[item]
          });
        }
        this.apps = listApp;
        this.selectedApps = this.apps.map(item => item.value);
        this.getDataTable();
      }
    });
  }

}
